import api from '@/api'
export default{
    namespaced:true,
    state: {
        userinfo:{

        }
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_USERINFO:(state,userInfo)=>{
        //用户名
        state.userinfo = {...userInfo};
        },
        CLEAR_USERINFO:(state,userInfo)=>{
        //用户名
        state.userinfo = {};
        },
    },
    actions: {
        async getUserInfo({ commit }) {
         
        let result = await api.getUserInfo().catch(error => {
            console.error("getUserInfo异常:", error);
            return null; // 返回默认值，让result有初始值
        });
        //console.log(result)
        //注意：当前登录请求现在使用mock数据，mock数据code是20000
        if(result.code==200){
            const  {data}  = result;
            console.log('userinfo',data)
            //vuex存储token
            commit('SET_USERINFO',data);
            return data;
        }else{
            return Promise.reject(new Error(result.message));
        }
    },
    },
}